import React, { useReducer, useEffect, useContext } from "react";
import {
  fetchData,
  contentReducer,
  initialStateContent,
} from "../utils/fetchData";
import { LanguageContext } from "../App";
import variousNames from "../utils/variousNames";


const Calendar: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const [state, dispatch] = useReducer(contentReducer, initialStateContent);
  const varNames = variousNames[language];

  useEffect(() => {
    fetchData(language, "courses.json", dispatch);
  }, [language]);

  const { contentDataArray, error, loading } = state;
  // Filter
  const allowedIds = ["tig", "mag", "mig", "mma"];

  // Filter the array
  const filteredContentDataArray = contentDataArray.filter((content) =>
    allowedIds.includes(content.id)
  );

  /*const nextCourses = filteredContentDataArray.map(({ id, nextCourse }) => ({
    id,
    nextCourse,
  }));
  */

  const nextCoursesTrue = !filteredContentDataArray.every(
    ({ nextCourse }) => nextCourse === ""
  );

  
  return (
    <div className="calendar-container">
      {loading && <div>Loading...</div>}
      {error && <div>{error}</div>}
      {!loading && !error && contentDataArray.length === 0 && (
        <div>No data available.</div>
      )}
      {filteredContentDataArray.length > 0 && nextCoursesTrue ? (
        <>
          <h3 className="calendar-h3">{`${varNames.nextCourses}: `}</h3>
          {(() => {
      const tigItem = contentDataArray.find((item) => item.id === "tig");
      return tigItem && tigItem.nextCourse ? (
        <p className="calendar-text">{tigItem.nextCourse}</p>
      ) : (
        <div className="no-content"></div>
      );
    })()}
        </>
      ) : (
        <div className="no-content"></div>
      )}
    </div>
  );
};

export default Calendar;
